import React from 'react';

interface ToggleSwitchProps {
    checked: boolean;
    onChange: () => void;
    size?: 'sm' | 'md';
}

export default function ToggleSwitch({ checked, onChange, size = 'md' }: ToggleSwitchProps) {
    const isSmall = size === 'sm';
    return (
        <label className="relative inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                className="sr-only peer"
                checked={checked}
                onChange={onChange}
            />
            <div className={`${isSmall ? 'w-9 h-5' : 'w-11 h-6'} bg-slate-300 dark:bg-slate-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full ${isSmall ? 'after:h-4 after:w-4' : 'after:h-5 after:w-5'} after:transition-all peer-checked:bg-electric-blue`}></div>
        </label>
    );
}
